/* eslint-disable react/jsx-no-useless-fragment */
/*
    * Project: forca
    * File Created: Thursday, 7th April 2022 10:48:42 am
    * Author: Teodor Moquist (teodor@moquist.dk)
    */

import React, { useEffect } from 'react';

//import Mitid from './components/mitid';
import NemID from './components/nemid';

export const SsoPensionsinfo = (props: any) => {
	useEffect(() => {
		window.App.Util.getLoginType();
	}, []);

	return (
		<>
			<NemID { ...props } />
		</>
	);
};

export default SsoPensionsinfo;

//<>
//{window.App.Util.isLoginType(['mitid']) ? (
//		<NemID {...props} />
//	) : (
//		<NemID {...props} />
//	)}
//</>